<template>
	<div class="login-layout">
		<div class="login-left">
			<img class="logo" :src="siteCfg && siteCfg.webtool_logo ? siteCfg.webtool_logo : 'https://img.huajuanyun.com/utools/2023/911/1694415838004.png'" alt="">
			<div class="desc">
				<h3>{{siteCfg ? siteCfg.webtool_login_slogon : 'PC端批量转链工具'}}</h3>
				<p>{{siteCfg ? siteCfg.webtool_login_desc : '满足代理多场景化转链·降本提效'}}</p>
			</div>
			<img class="logo-bg" :src="siteCfg && siteCfg.webtool_login_img ? siteCfg.webtool_login_img : 'https://img.huajuanyun.com/utools/2023/913/1694590020148.png'" alt="">
		</div>
		<div class="login-container">
			<img class="mobile-logo" :src="siteCfg && siteCfg.webtool_logo ? siteCfg.webtool_logo : 'https://img.huajuanyun.com/utools/2023/911/1694415838004.png'" alt="">
			<div class="login-card">
				<!-- 拿到缓存之后再加载 -->
				<router-view v-if="siteCfg" />
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {}
	},
	computed: {
		siteCfg() {
			return this.$store.getters.config
		}
	}
}
</script>

<style lang="scss" scoped>
.login-layout {
	min-width: 1280px;
    height: 100vh;
    min-height: 700px;
	background: #fff;
    box-sizing: border-box;
    display: flex;
	.login-left {
		width: 30%;
		height: 100%;
		padding: 0 10px;
		background-image: radial-gradient(100% 157.26% at 0 0,rgba(217,242,255,.32) 0,rgba(242,240,252,.32) 27.87%,rgba(191,216,255,.32) 100%);
		display: -ms-flexbox;
		display: flex;
		-ms-flex-direction: column;
		flex-direction: column;
		-ms-flex-align: center;
		align-items: center;
		-ms-flex-pack: center;
		justify-content: center;
		.logo {
			width: 180px;
			height: auto;
			position: absolute;
			top: 30px;
			left: 40px;
		}
		.desc {
			font-size: 22px;
			color: #666666;
			text-align: center;
			h3{
				font-size: 38px;
				margin-bottom: 10px;
				color: #111111;
			}
		}
		.logo-bg {
			width: 80%;
			height: auto;
			margin-top: 50px;
		}
	}
	.login-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: #fff;
		padding: 32px 24px;
		box-sizing: border-box;
		.mobile-logo {
			display: none;
		}
		.login-card {
			width: 360px;
			max-width: 100%;
		}
	}
}

@media screen and (max-width: 767px) {
	.login-layout {
		min-width: 0;
		min-height: 100vh;
		height: auto;
		display: block;
	}
	.login-layout .login-left {
		display: none;
	}
	.login-layout .login-container {
		width: 100%;
		min-height: 100vh;
		padding: 32px 20px;
		justify-content: flex-start;
		padding-top: 56px;
		.mobile-logo {
			display: block;
			width: 140px;
			height: auto;
			margin: 0 auto 28px;
		}
		.login-card {
			width: 100%;
			max-width: 420px;
		}
	}
}
</style>
